import { getWebApp } from "./telegram";

/** Всё, что приложению нужно от окружения (Telegram или обычный браузер). Подменяется в тестах. */
export interface Platform {
  /** start_param из ссылки-приглашения. */
  readonly startParam: string | undefined;
  /** location.search — для старых ссылок с ?room=. */
  readonly search: string;
  openLink: (url: string) => void;
  openTelegramLink: (url: string) => void;
  /** Есть ли встроенный сканер QR (только внутри Telegram). */
  readonly canScanQr: boolean;
  /** Открывает сканер; null — если игрок закрыл его, ничего не отсканировав. */
  scanQr: () => Promise<string | null>;
}

export function createBrowserPlatform(win: Window = window): Platform {
  const tg = getWebApp(win);
  return {
    startParam: tg?.initDataUnsafe.start_param,
    search: win.location.search,
    canScanQr: Boolean(tg?.showScanQrPopup),
    openLink(url) {
      if (tg?.openLink) tg.openLink(url);
      else win.open(url, "_blank", "noopener");
    },
    openTelegramLink(url) {
      if (tg?.openTelegramLink) tg.openTelegramLink(url);
      else win.open(url, "_blank", "noopener");
    },
    scanQr() {
      const webApp = tg;
      if (!webApp?.showScanQrPopup) return Promise.resolve(null);
      return new Promise((resolve) => {
        const onClosed = () => resolve(null);
        webApp.onEvent?.("scanQrPopupClosed", onClosed);
        webApp.showScanQrPopup?.({ text: "Сканируйте QR-код комнаты" }, (data) => {
          webApp.offEvent?.("scanQrPopupClosed", onClosed);
          resolve(data);
          return true; // закрыть окно сканера
        });
      });
    },
  };
}
